module.exports = __webpack_public_path__ + "nc_static/media/personal-details.bf20833c.svg";